/**
 * Board configuration — tunable behaviour that isn't domain logic. Centralised
 * here (not hard-coded in components) so it's easy to find and adjust.
 */

/**
 * How many days a Done card stays on the board after its last status change.
 * The default view hides Done cards older than this; a toggle reveals them.
 * Overridable at build time via VITE_BOARD_DONE_VISIBLE_DAYS.
 */
export const DONE_VISIBLE_DAYS = Number(import.meta.env.VITE_BOARD_DONE_VISIBLE_DAYS ?? 3)

/** A deadline this many days away or sooner, on an order not yet done, is flagged at risk on the list. */
export const DEADLINE_AT_RISK_DAYS = 2
